import { render, staticRenderFns } from "./SecondSettingsComp.vue?vue&type=template&id=18089b40&scoped=true&"
import script from "./SecondSettingsComp.vue?vue&type=script&lang=js&"
export * from "./SecondSettingsComp.vue?vue&type=script&lang=js&"
import style0 from "./SecondSettingsComp.vue?vue&type=style&index=0&id=18089b40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18089b40",
  null
  
)

export default component.exports